import { render, staticRenderFns } from "./Chi_chineseNewYearSection.vue?vue&type=template&id=4d71eef4&scoped=true"
import script from "./Chi_chineseNewYearSection.vue?vue&type=script&lang=ts"
export * from "./Chi_chineseNewYearSection.vue?vue&type=script&lang=ts"
import style0 from "./Chi_chineseNewYearSection.vue?vue&type=style&index=0&id=4d71eef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d71eef4",
  null
  
)

export default component.exports